// extracted by mini-css-extract-plugin
module.exports = {"box":"TagBoxWidget_box__EP7Wl","withFloatingLabel":"TagBoxWidget_withFloatingLabel__3jt0n","disabled":"TagBoxWidget_disabled__3YLP_"};